__turbopack_context__.v({
  "content": "_6Kc-7a_content",
  "dropdownMenu": "_6Kc-7a_dropdownMenu",
  "item": "_6Kc-7a_item",
  "loadingSkeleton": "_6Kc-7a_loadingSkeleton",
  "selector-skeleton-loading": "_6Kc-7a_selector-skeleton-loading",
  "separator": "_6Kc-7a_separator",
  "wrapper": "_6Kc-7a_wrapper",
});
